import { Tooltip } from "@mui/material";

const UITooltip = (props) => {
  const { title, children, topLabel, disable } = props;

  return (
    disable? <>{children}</>: <Tooltip
      enterTouchDelay={0}
      disableInteractive
      title={
        <div>
          {topLabel && <div style={{ marginBottom: "8px" }}>{topLabel}</div>}
          {title}
        </div>
      }
      {...props}
    >
      {children}
    </Tooltip> 
  );
};

export default UITooltip;
